import { useFolder } from 'hooks/queries/folders/useFolder'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useRootStore } from 'stores/RootStore'
import { FolderMenu } from './FolderMenu'
import { FolderMenuContainerProps } from './Types'
import { MovePanel } from './MovePanel'

export const FolderMenuContainer = observer(({ id, onAction, dismiss, ...rest }: FolderMenuContainerProps) => {
  const [showMove, setShowMove] = useState(false)
  const { files } = useRootStore()

  /**
   * This fetching of folder + file is due to the fact that the data is sparse
   * across different endpoints.
   */
  const { data } = useFolder(id, { cacheTime: Infinity })
  const file = files.get(id)
  useEffect(() => {
    files.fetch(id)
  }, [id, files])

  if (!data || !file || !data.folder.handbook) {
    return null
  }

  const {
    database_mode = false,
    default_view,
    default_project = false,
    pinned = false,
    ancestor_projects,
    handbook,
    status_kanban_view_id,
  } = data.folder

  if (showMove) {
    return <MovePanel file={file} dismiss={dismiss} />
  }

  return (
    <FolderMenu
      {...rest}
      folder={{
        key: file.id,
        almanac_file: file,
        pinned,
        ancestor_projects,
        database_mode,
        default_view,
        default_project,
        has_workflow: !!status_kanban_view_id,
        handbook: {
          key: handbook.key,
        },
      }}
      onAction={(action) => {
        if (action === 'move') {
          setShowMove(true)
        }
        onAction?.(action)
      }}
    />
  )
})
